import React, { useState, useEffect, useRef } from 'react';
import { QRCode } from "react-qrcode-logo";
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAndroidAlt } from '@fortawesome/free-solid-svg-icons';
//Components
import Loading from '../../components/Loading/Loading';

//Api
import downloadAplicativos_api from '../../api/DownloadAplicativos_api';

//Helpers
import { showMessage } from '../../helpers/message';
import { getSessionCookie } from '../../helpers/cookies';

//Assets
import logoImg from '../../assets/img/logoQrCode.png';


export default function DownloadAplicativos() {
    //Referencia ao link do app
    const refLink = useRef();

    //Estado que guarda o link do aplicativo para download
    const [linkApp, setLinkApp] = useState("");

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Dados do usuario
    const usuario = getSessionCookie();

    //Pega o link do download do app assim que a tela é carregada
    useEffect(() => {
        setLoading(true);
        downloadAplicativos_api.GetLink().then(response => {
            setLinkApp(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }, []);

    return (
        <div className=' d-flex align-items-center justify-content-center bg-light p-4 m-4 rounded-3 shadow'>
            <a href={linkApp} ref={refLink} target={"_blank"}></a>
            {loading && <Loading />}
            <div className='d-flex align-items-center justify-content-center flex-column'>
                <h4 className='fw-light'><span className="fw-bold">Aplicativo</span> {usuario.acesso.sigla=="TR"?"do coletor":"do fiscal"}</h4>
                <p>Escaneie o QrCode ou clique no botão abaixo para realizar o download do aplicativo</p>
                <div className="d-flex align-items-center flex-column justify-content-center">

                    <div className="d-flex align-items-center justify-content-center shadow rounded-3">

                        <QRCode
                            value={linkApp}
                            enableCORS={true}
                            logoImage={logoImg}
                            size="250"
                            logoOpacity={1}
                            qrStyle={"squares"}
                            fgColor={"#000"}
                            bgColor={"#fff"}
                            logoWidth={60}
                            logoheight={60}
                        />
                    </div>
                    <Button onClick={() => refLink.current.click()} className={"mt-4"} color='success' contained><FontAwesomeIcon icon={faMobileAndroidAlt} className=" me-3" /> Download do app</Button>
                </div>
            </div>
        </div>
    );
}